(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SmsPatternDetailController', SmsPatternDetailController);

    SmsPatternDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Company', 'SettingInfo', 'AgreementInfo', 'LocationInfo', 'MetaTag'];

    function SmsPatternDetailController($scope, $rootScope, $stateParams, entity, Company, SettingInfo, AgreementInfo, LocationInfo, MetaTag) {
        var vm = this;

        vm.smsPattern = entity;

        // var unsubscribe = $rootScope.$on('tikonApp:companyUpdate', function (event, result) {
        //     vm.smsPattern = result;
        // });
        // $scope.$on('$destroy', unsubscribe);
    }
})();
